import { render, staticRenderFns } from "./ClientOnsitePayments.vue?vue&type=template&id=0f7b83c1&"
import script from "./ClientOnsitePayments.vue?vue&type=script&lang=js&"
export * from "./ClientOnsitePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports